
import React from "react";
import * as Hooks from "../../../../../hooks";
import { i18nManager } from "../../../../../i18n";
import { Schemes, Utils } from "../../../../../utils";
import { Elements } from "../../../../shared/Elements";
import * as ReactRouterDom from "react-router-dom";
import { ConfirmDialog } from "../../../../shared/ConfirmDialog";
import LoadingGif from "../../../assets/images/loading_circle.gif";
import { Button, ButtonManageRef, DateInput, Dropdown, Form, FormControl, Scheme, Subscriber, TextInput, useSubscription } from "@rivtn/noseur";
import { ApiResponseData, BaseService, CountryService, ICountry, IMember, IHost, SanitizedResponse, HostRole, HostService } from "../../../../../services";
import { CreateTournamentSectionProps, CreateTournamentSection } from "../CreateTournament";

function StageAndFormat(props: CreateTournamentSectionProps) {

    const { active, tournamentEditionState } = props;
    const [themeMode, _] = Hooks.useThemeMode();
    const [tournament, setTournament] = tournamentEditionState;
    const labels = i18nManager.Labels.host.create_tournament.stage_and_format;

    React.useEffect(() => {

    }, []);

    return (<div className="create-tournament-f flow details" ref={props.ref}>
        {!active && (<div className="overlay" onClick={() => props.setActiveSection(CreateTournamentSection.STAGE_AND_FORMAT, undefined, true)} />)}
        <span className="title">{labels.title}</span>
        <Form className="content" scheme={Schemes.OMNEHOST} style={{ marginTop: 20, width: "100%" }}>
            <hr style={{ width: "auto" }} />
            <span style={{ marginTop: 0 }}>{labels.stage_info.label} <a target="_blank" href={labels.stage_info.article_link}>{labels.stage_info.read_more}</a></span>
            <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.choose_stage, }}
                options={labels.stages} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                    <span>{option.desc} <a target="_blank" href={option.article_link}>{labels.read_more}</a></span>
                </div>)} selectedOptionIndex={labels.stages.findIndex((f) => f.value === tournament.stage)} onSelectOption={(o) => {
                    setTournament({ ...tournament, stage: o.value });
                }} />
            <hr style={{ width: "auto", marginTop: 20 }} />
            <span style={{ marginTop: 0 }}>{labels.format_info.label} <a target="_blank" href={labels.format_info.article_link}>{labels.format_info.read_more}</a></span>
            <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.select_format, }}
                options={labels.formats} optionTemplate={(option: any) => (<div key={option.value} style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 500, marginBottom: 3, fontSize: 16 }}>{option.label}</span>
                    <span>{option.desc} <a target="_blank" href={option.article_link}>{labels.read_more}</a></span>
                </div>)} selectedOptionIndex={labels.formats.findIndex((f) => f.value === tournament.format)} onSelectOption={(o) => {
                    setTournament({ ...tournament, format: o.value });
                }} />
            <hr style={{ width: "auto", marginTop: 20 }} />
            <span style={{ marginTop: 0 }}>{labels.stage_update_info} <span style={{ color: "#FF7171" }}>{labels.stage_note}</span></span>
        </Form>
        <div className="controls">
            <Button textOnly scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.prev} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.PRIZE_POOL, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
            <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.next} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.SCORING_AND_TIE_BREAKING, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
        </div>
    </div>);

}

export default StageAndFormat;
